export const management = {
  routes: [
  ],
};
